/* eslint-disable default-case */
import agent from './agent';
import { magicLogin, logout, register, singpassLogin } from '../Pages/Login/LoginSlice';

const localStorageMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case register.fulfilled.type:
    case singpassLogin.fulfilled.type:
      if (action.payload.access_token) {
        window.localStorage.setItem('jwt', action.payload.access_token);
        window.localStorage.setItem('permissions', JSON.stringify(action.payload.permissions));
        agent.setToken(action.payload.access_token);
      }
      break;
    case magicLogin.fulfilled.type:
      if (action.payload.access_token) {
        window.localStorage.setItem('jwt', action.payload.access_token);
        window.localStorage.setItem('permissions', JSON.stringify(action.payload.permissions));
        agent.setToken(action.payload.access_token);
      }
      break;

    case logout.type:
      window.localStorage.removeItem('jwt');
      agent.setToken(undefined);
      break;
  }

  return next(action);
};

export { localStorageMiddleware };
